import { render, staticRenderFns } from "./FormulasDialog.vue?vue&type=template&id=2d320cba&scoped=true&"
import script from "./FormulasDialog.vue?vue&type=script&lang=js&"
export * from "./FormulasDialog.vue?vue&type=script&lang=js&"
import style0 from "./FormulasDialog.vue?vue&type=style&index=0&id=2d320cba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d320cba",
  null
  
)

export default component.exports